var render = function render(){
  var _vm$config$rightSideb;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "right-sidebar__marker-guide"
  }, _vm._l((_vm$config$rightSideb = _vm.config.rightSidebar) === null || _vm$config$rightSideb === void 0 ? void 0 : _vm$config$rightSideb.propertyGuide.items, function (status) {
    return _c('div', {
      key: status,
      staticClass: "guide"
    }, [_c('AvailabilityMarker', {
      attrs: {
        "status": status,
        "isDisplayHome": status === 'Display Home'
      }
    }), _c('div', {
      staticClass: "guide__label"
    }, [_vm._v(_vm._s(_vm.config.markers[_vm.camelCase(status)].label[_vm.language.code]))])], 1);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }